const count = value => {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
}

export const serverTaskCounts = (viewCounts, total) => {
  if (!viewCounts) return null
  return {
    myTasks: count(viewCounts.myTasks),
    allTasks: count(total ?? viewCounts.allTasks),
    starred: count(viewCounts.starred),
    today: count(viewCounts.today),
    overdue: count(viewCounts.overdue),
    myOverdue: count(viewCounts.myOverdue),
    awaitingApproval: count(viewCounts.awaitingApproval),
    onHold: count(viewCounts.onHold),
    completed: count(viewCounts.completed),
    completedLate: count(viewCounts.completedLate)
  }
}

const isTeamCategory = category => !!category && category.startsWith('team_')

export const categoryFilterChange = (selectedCategory, filters = {}) => {
  const category = !selectedCategory || selectedCategory === 'all_tasks' ? null : selectedCategory
  const change = {}
  if ((filters.category || null) !== category) change.category = category
  if (isTeamCategory(category)) {
    const teamId = category.replace('team_', '')
    if (String(filters.teamId ?? '') !== teamId) change.teamId = teamId
  } else if (isTeamCategory(filters.category) && filters.teamId) {
    change.teamId = null
  }
  return Object.keys(change).length ? change : null
}

export const formatNavCount = value => {
  const n = Number(value) || 0
  return n > 999 ? '999+' : n.toLocaleString('en-GB')
}

export const formatRailCount = value => {
  const n = Number(value) || 0
  return n > 99 ? '99+' : String(n)
}

export const taskEmptyState = ({ category, label, searching }) => {
  if (searching) return { title: 'No tasks found', description: 'Try a different search, or clear the filters.', showCreate: false }
  if (category && category !== 'all_tasks') {
    return { title: `Nothing in ${label} right now`, description: 'Tasks will show here as soon as any match this view.', showCreate: false }
  }
  return {
    title: 'No tasks yet',
    description: 'Tasks are pieces of work you give to someone. They fill in a form, and you can follow their progress and approve the result.',
    showCreate: true
  }
}
